import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };
const base = `${API_BASE_URL}/Purchase`;

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET cost centers the current role can issue stock from
export const getCostCenterCodesDI = async (UID, RID) => {
    try {
        const res = await axios.get(`${base}/GetCostCenterCodesDI`, {
            params: { UID, RID },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET item search categories for Daily Issue
export const getCategoriesDI = async () => {
    try {
        const res = await axios.get(`${base}/GetcategoriesDI`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the staged (already lot-assigned) issue items for a cost center — this is
// always a fresh server read, never client-tracked: item Qty/Amount are set server-side
// by SaveTempNewItemsDailyIssue, not entered directly in this grid.
export const getItemsDailyIssueSK = async (CCode, RID) => {
    try {
        const res = await axios.get(`${base}/GetItemsDailyIssueSK`, {
            params: { CCode, RID },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET item-code/name prefix search, shared with the Stock Transfer module —
// Typ: '1' = by code, '2' = by name
export const getAutoCompleteItemTransfer = async (Pfx, Typ, Cat, CC) => {
    try {
        const res = await axios.get(`${base}/GetAutoCompleteItemTransfer`, {
            params: { Pfx, Typ, Cat, CC },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the lot/batch-level available-quantity breakdown for one item at a cost center
export const getNewDIItemsIssueTempDetails = async (Itemcode, CCcode) => {
    try {
        const res = await axios.get(`${base}/NewDIItemsIssueTempDetails`, {
            params: { Itemcode, CCcode },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — assign quantity from one or more lots to an item, staging it into the main grid
// payload: { Trowids, TItemCodes, TNewQtys, Ttblnames, TCCCode, TSingleItemcode, RoleID, Createdby }
export const saveTempNewItemsDailyIssue = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveTempNewItemsDailyIssue`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — remove one staged item from the main grid
// payload: { ItemCode, FromCC }
export const deleteDailyIssueItems = async (payload) => {
    try {
        const res = await axios.post(`${base}/DeleteDailyIssueItems`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize and submit the daily issue transaction
// payload: { Qty, ItemCode, Amount, Date, Remarks, FromCC, Createdby, RoleID }
export const saveDailyIssueItems = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveDailyIssueItems`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};
